import { useState, useRef, useEffect } from "react";
import { initQueryEngine, tokenize, validate, parse, buildSQL } from "./queryEngine";
import { fetchRatios } from "./ratios";

import * as Yup from 'yup';
import {
   Control,
   FieldErrors,
   useForm,
   useFormState,
   useWatch,
   Controller
 } from 'react-hook-form';
import axios from 'axios';  
import { yupResolver } from '@hookform/resolvers/yup';
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import {Links} from '../../routes/PathLink'
import {API_ENDPOINT,toast_anim , toast_anim_error} from '../../components/config/Common'

//import "./screens.css";
import Header from "../../layouts/Header";
import Footer from "../../layouts/Footer";
import getCaretCoordinates from "textarea-caret";
import TextArea  from "../../components/ui/text-area";
//import Button from "../../components/ui/Button";
import Button from 'components/ui/Button.tsx'
import Input from 'components/ui/input.jsx'
import Checkbox from 'components/ui/checkbox/checkbox.tsx'
import {useCreateScreenQuery} from '../../data/screen-details';
import CompanyTable  from "../../components/CompanyTable";
import Breadcrumb  from "../../components/Breadcrumb";
const TOKEN_RULES = [
  { type: "LOGIC", regex: /^(AND|OR)\b/i },
  { type: "OP", regex: /^(>=|<=|>|<|=)/ },
  { type: "LPAREN", regex: /^\(/ },
  { type: "RPAREN", regex: /^\)/ },
  { type: "MATH", regex: /^(\+|\-|\*|\/)/ },
  { type: "NUMBER", regex: /^\d+(\.\d+)?/ },
  {
    type: "RATIO",
    regex: /^(?!AND\b|OR\b)[A-Za-z_]+(?:\s+(?!AND\b|OR\b)[A-Za-z_]+)*/
  }
];

const SignupSchema = Yup.object().shape({
    name: Yup.string()
          .required('You must need to provide your query name.')
});

const defaultValues = {     
   name:'',
   description:'',
  is_public:true,
 };

export default function AddScreens() {
    let navigate = useNavigate();
    const [text, setText] = useState("");
    const [errorMsg, setErrorMsg] = useState("");
    //const [sql, setSql] = useState("");

    const [query, setQuery] = useState("");
    const textareaRef = useRef(null);
    const [sql, setSql] = useState("");

    const [suggestions, setSuggestions] = useState([]);
    const [caretPos, setCaretPos] = useState({ top: 0, left: 0 });
    const [showPopup, setShowPopup] = useState(false);
    const [RATIOS, setRatios] = useState([]);
    const [LABELS, setLabels] = useState([]);
    const [FIELD_ALIASES, setAliases] = useState([]);
    const [OPERATORS, setOperators] = useState([]);
    const [SUGGESTION, setSuggestion] = useState([]);
    const [LABELS_MAP, setLabelsMap] = useState([]);
    const [allLabels, setAllLabels] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState('all');

    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(process.env.REACT_APP_PAGE_LIMIT);
    const [orderBy, setOrder] = useState('created_at');
    const [sortedBy, setColumn] = useState('desc');
    const [saveQuery, setSaveQuery] = useState(false);

    const [showRatios, setShowRatios] = useState(true);
    const [searchText, setSearchText] = useState("");

    const { register, handleSubmit , control, reset, setValue, setError, formState: { errors },} = useForm({
          defaultValues: defaultValues,
          resolver: yupResolver(SignupSchema),
          shouldFocusError:false,
       });
    
    useEffect(() => {
    
      initQueryEngine();
      fetchRatios().then(({ RATIOS, LABELS, FIELD_ALIASES, OPERATORS, SUGGESTION, LABELS_MAP }) => {
        setRatios(RATIOS);
        setLabels(LABELS);
        setAliases(FIELD_ALIASES);
        setOperators(OPERATORS);
        setSuggestion(SUGGESTION);
        setLabelsMap(LABELS_MAP);
        setAllLabels(LABELS);
      });
    }, []);

    const {
        product,
        screenDetails,
        paginatorInfo,
        isLoading,
      } = useCreateScreenQuery({ 
        query:sql,
        limit: pageSize,
        page,    
        orderBy,
        sortedBy,
      });

      const onPagination = (current) => {
    //console.log("current Page",current);
    setPage(current);
  }
  const onPageSize = (value) => {
    setPageSize(value);
    setPage(1);
  }  

  const totalPages = Math.ceil(paginatorInfo?.total / pageSize);

      //console.log("screenDetails",product);

    const getCurrentToken = (text) => {
      
        return text
            .split(/[\s><=()+\-*/]+/) // split by operators & spaces
            .pop();
    };
    

    const handleChange = (e) => {
            const value = e.target.value;
            //setText(value);
            setQuery(value);
    
            const textarea = textareaRef.current;
            if (!textarea) return;
    
            const cursor = textarea.selectionStart;
            if (cursor === null) return;
    
            const textBeforeCursor = value.slice(0, cursor);
            const currentToken = getCurrentToken(textBeforeCursor);

            //console.log("Current Token:", currentToken);
    
            // 🔴 Do not show popup for short tokens
            if (!currentToken || currentToken.length < 2) {
                setShowPopup(false);
                return;
            }
    
            // 🔴 Do not trigger for logical operators
            if (["AND", "OR"].includes(currentToken.toUpperCase())) {
                setShowPopup(false);
                return;
            }
    
            /* const filtered = SUGGESTION?.filter((r) =>
                r.toLowerCase().startsWith(currentToken?.toLowerCase())
            ); */
            const term = currentToken?.toLowerCase().trim();

            const filtered = SUGGESTION.filter(r =>
              r.toLowerCase().includes(term)
            );
    
            if (!filtered.length) {
                setShowPopup(false);
                return;
            }
    
            // ✅ caret position
            const coords = getCaretCoordinates(textarea, cursor);
            
            if (!coords) return;
    
            /* setCaretPos({
                top: coords.top + 28,
                left: coords.left,
            }); */
            const rect = textarea.getBoundingClientRect();
            setCaretPos({
              top: rect.top + window.scrollY + coords.top + 24,  // below cursor
              left: rect.left + window.scrollX + coords.left,
            });
    
            setSuggestions(filtered);
            setShowPopup(true);
        };

        function validateGrammar(tokens) {
  if (!tokens.length) return;

  // Expression must start with a RATIO
  if (tokens[0].type !== "RATIO") {
    throw new Error("Query must start with a ratio (e.g. Sales, ROCE, Market Capitalization).");
  }

  for (let i = 0; i < tokens.length; i++) {
    const t = tokens[i];
    const next = tokens[i + 1];

    // RATIO must be followed by OP
    if (t.type === "RATIO" && (!next || next.type !== "OP")) {
      throw new Error(`"${t.value}" must be followed by an operator (>, <, =, >=, <=).`);
    }

    // OP must be followed by NUMBER
    if (t.type === "OP" && (!next || next.type !== "NUMBER")) {
      throw new Error(`Operator "${t.value}" must be followed by a number.`);
    }

    // NUMBER must be followed by LOGIC or RPAREN or end
    if (t.type === "NUMBER" && next && !["LOGIC", "RPAREN"].includes(next.type)) {
      throw new Error(`"${next.value}" is not valid after number ${t.value}. Use AND or OR.`);
    }

    // LOGIC must be followed by RATIO or LPAREN
    if (t.type === "LOGIC" && (!next || !["RATIO", "LPAREN"].includes(next.type))) {
      throw new Error(`"${t.value}" must be followed by a ratio (e.g. Sales, ROCE).`);
    }
  }
}

  const run = () => {
    try {
      setErrorMsg("");

    const trimmed = query.trim();

    // 🛑 Block empty query
    if (!trimmed) {
      throw new Error("Please enter a query before running.");
    }

    // 🚨 Prevent trailing operators
    if (/(AND|OR|>=|<=|>|<|=|\+|\-|\*|\/|\()$/i.test(trimmed)) {
      throw new Error("Query cannot end with an operator. Please complete the condition.");
    }
    console.log("Running Query:", trimmed);

    const tokens = tokenize(trimmed);

    console.log("Tokens:", tokens);

    validate(tokens);
    validateGrammar(tokens); 
    const ast = parse(tokens);

    const generatedSql = buildSQL(ast);
    setSql(generatedSql);

    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 1000)
    

    } catch (e) {
      setSql("");
      setErrorMsg(e.message);
    }
  };

  const insertSuggestion = (suggestion) => {
        const textarea = textareaRef.current;
        const cursor = textarea.selectionStart;

        const beforeCursor = query.slice(0, cursor);
        const afterCursor = query.slice(cursor);

        const token = getCurrentToken(beforeCursor);

        const newBefore =
            beforeCursor.slice(0, beforeCursor.length - token.length) +
            suggestion +
            " ";

        const newQuery = newBefore + afterCursor;
        //setText(newQuery);
        setQuery(newQuery);
        setShowPopup(false);

        requestAnimationFrame(() => {
            textarea.focus();
            textarea.selectionStart = textarea.selectionEnd = newBefore.length;
        });
    };

    const insertAtCursor = (text) => {


        const textarea = textareaRef.current;
        const start = textarea.selectionStart;
        const end = textarea.selectionEnd;

        const newValue =
        query.substring(0, start) +
        text +
        query.substring(end);

        setQuery(newValue);
        //setText(newValue);

        // Move cursor after inserted text
        setTimeout(() => {
        textarea.focus();
        textarea.selectionStart = textarea.selectionEnd =
            start + text.length;
        }, 0);
    };

    const insertOperator = (op) => {
        const textarea = textareaRef.current;
        const cursor = textarea.selectionStart;

        const before = query.slice(0, cursor);
        const after = query.slice(cursor);

        const isLogical = ["AND", "OR"].includes(op);

        const insertText = isLogical
            ? `${op}\n\n`
            : ` ${op} `;

        const newQuery = before + insertText + after;

        setQuery(newQuery);
        //setText(newQuery);

        requestAnimationFrame(() => {
            textarea.focus();
            textarea.selectionStart = textarea.selectionEnd =
            before.length + insertText.length;
        });
    };

  
  const openSaveForm = () => {
    setSaveQuery(true);
  }

  const saveQueryData = async (values) => {
    //console.log('Saved Query Data====',values, sql)
  
    let fromdata = {
           'name': values?.name,
           'description':values?.description,
           'system_query': sql,
           'user_id': localStorage.getItem('user_id'),
           'user_query':query,
            'is_public': values?.is_public ? 1 : 0,
          } 
    
           //console.log('fromdata====',fromdata)
         
          axios
         .post(API_ENDPOINT+'/screens_create', fromdata)
         .then((response) => {
            //console.log("RESPONSE",response.data);
            if(response.data?.status == 200){
                toast_anim('Query saved successfully.');
                setSaveQuery(false);
                reset(defaultValues);
            } else {
              toast_anim_error('Error saving query. Please try again.');
            }
            navigate(`${Links.SCREENS}/${response.data?.data?.slug}`, { replace: true });
            
           //setPost(response.data);
            
         });
    return false;
  }

  const filterCategory = (category) => {
    //console.log("Filtering by category:", category);
    if(category === selectedCategory){
      setLabels(allLabels);
      setSelectedCategory('all');
      return;
    }
    
    const filtered = allLabels.filter(r => 
      r.category === category
    );
    //console.log("Filtering by category:", filtered);
    setLabels(filtered);
    setSelectedCategory(category);
  };

  const handleSearch = (text) => {
  setSearchText(text);

  const keyword = text.toLowerCase().trim();

  const filtered = allLabels.filter(ratio =>
    ratio.name.toLowerCase().includes(keyword) ||
    ratio.slug.toLowerCase().includes(keyword) ||
    ratio.description.toLowerCase().includes(keyword)
  );

  setLabels(filtered);
};

const breadcrumb = [
  {
    name:'Home',
    link:`${process.env.REACT_APP_URL}`,
  },
  {
    name:`Screens`,
    link:`${process.env.REACT_APP_URL}${Links.SCREENS}`
  },
  {
    name:`Create New Screen`,
    link:null
  },
]

  return (
    <>
        <Header />
        <div className="space-y-5 px-5">
          <Breadcrumb breadcrumb={breadcrumb} />
          {saveQuery ?
          <>
          <section className="w-2/3 mx-auto bg-white shadow-sm z-50 rounded-xl p-5">
            <h2 className="text-2xl mb-5">Save Query</h2>
            <form onSubmit={handleSubmit(saveQueryData)}>  
            <div className="flex flex-col md:flex-col gap-5">
              <div className="w-full">
                
                {/* <input
                  type="text"
                  className="w-full border border-gray-300 rounded px-3 py-2"
                  placeholder="Enter query name"
                /> */}
                <Input                
                    label={`Query Name`}
                    variant="outline"
                    className="mb-5"
                    required
                    placeholder="eg. The Cash Bargins"
                    {...register('name')}  
                    error={errors.name?.message}               
                  /> 
              </div>
              <div className="w-full">                
                <TextArea               
                  label={`Description`}   
                  rows={6}                  
                  placeholder="eg. Companies with over 20% growth in sales over last 3 years."
                  {...register('description')}
                />
              </div>
              <div className="w-full">                
              <Checkbox 
                {...register('is_public')}
                className="mb-2"
                label="Make the query public? (Anyone can view this query)"
                defaultChecked={true}
                theme="primary"
              />
              </div>
              
            </div>
            <div className="my-5">
              <Button size="small" className="mr-3">Save</Button>
              <Button size="small" variant="outline" onClick={() => setSaveQuery(false)}>Cancel</Button>
            </div>
            <div className="w-full">
                  Query Preview:
                  <div className="mt-2 p-3 border border-gray-300 rounded bg-gray-50 text-sm whitespace-pre-wrap">
                    {query}
                  </div>
              </div>
            </form>
          </section>
          </>
          :
          
          <section className={`mx-auto bg-white shadow-sm z-50 rounded-xl p-5`}>
            {product && (
            <>
            <div className="flex items-center justify-between">
              <h2 className="text-2xl">Query Results</h2> 
              <Button className="my-2" onClick={openSaveForm} size="small">Save This Query</Button> 
            </div>
            
            <CompanyTable 
                    data={product} 
                    pageSize={pageSize} 
                    isLoading={isLoading} 
                    paginatorInfo={paginatorInfo}
                    totalPages={totalPages}
                    onPagination={onPagination}
                    onPageSize={onPageSize}
                />
                <div className="w-full flex justify-start mb-10"></div>
                </>
              )
            }
            {sql && !product && 
            <div className="w-full flex justify-center items-center px-10 py-10">
              <div className="animate-pulse w-full">
                
                <div className="space-y-2">
                  {[...Array(8)].map((_, i) => (
                    <div key={i} className="flex space-x-2">
                      <div className="h-10 bg-gray-200 rounded w-full"></div>
                      
                    </div>
                  ))}
                </div>
              </div>
            </div>
        }

            <h2 className="text-2xl">Search Query</h2>

            <div className="my-2 prose max-w-full">You can customize the query below:</div>
            {errorMsg && 
              <div className="w-[64.5%] bg-red-100 border border-red-400 text-red-700 px-4 py-1 rounded relative mb-3" role="alert">
                <span className="block sm:inline text-sm">{errorMsg}</span>
              </div>
              }
            <div className="flex flex-col md:flex-row gap-8 mb-2 justify-between">
              <div className="w-full md:w-[65%]">
                
                <TextArea
                  ref={textareaRef}
                  rows={6}
                  style={{ width: "100%", fontSize: 16 }}
                  value={query}
                  onChange={handleChange}
                  placeholder="Sales > 10 AND Market Cap < 5000 AND ROCE > 15"
                />
              </div>
              <div className="w-full md:w-[33%] bg-gray-50 p-3 rounded border border-gray-200">
                <h3 className="text-lg mb-2">Query Example</h3>
                <div className="text-sm text-gray-500 mt-1">
                  Market Cap {`>`} 500 AND <br />
                  PE {`<`} 15 AND <br />
                  ROCE {`>`} 22
                </div>
              </div>
            </div>
            <div className="flex flex-col md:flex-row justify-between items-center w-full md:w-[65%]">
            <Button className="my-2" onClick={run} size="small">▶ RUN THIS QUERY</Button>
            {/* <Button
              size="small"
              variant="outline"
              onClick={() => setShowRatios(v => !v)}
            >
              {showRatios ? "Hide Ratios ▲" : "Show Ratios ▼"}
            </Button> */}
            </div>

            {showPopup && (
                
              <ul
                className="bg-accent text-white overflow-hidden"
                style={{
                  position: "absolute",
                  top: caretPos.top,
                  left: caretPos.left,                  
                  borderRadius: 6,                  
                  listStyle: "none",
                  minWidth: 240,
                  boxShadow: "0 8px 20px rgba(0,0,0,.4)",
                  zIndex: 1000,
                }}
              >
                {suggestions.map((item) => (
                  <li
                    key={item}
                    onClick={() => insertSuggestion(item)}
                    className="px-4 py-2 hover:bg-accent-700/75 cursor-pointer"
                    onMouseDown={(e) => e.preventDefault()}
                  >
                    {item}
                  </li>
                ))}
              </ul>
              
            )}

      <div
        className="transition-all duration-500 ease-in-out overflow-hidden"
        
      >
      <h2 className="text-2xl mt-5">Quick Insert</h2>

      <div className="w-full flex flex-col md:flex-row gap-4 justify-between items-center ">
      {/* OPERATORS */}
        <div style={{ marginTop: 12 }}>
            {OPERATORS?.map((op) => (
            <Button
                key={op}                      
                size="small"
                className="mr-2 mb-2"
                variant="outline"
                onClick={() => insertOperator(` ${op} `)}
            >
                {op}
            </Button>
            ))}
        </div>
        <div className="flex flex-row items-center lg:justify-end w-full md:w-1/3 gap-2">
          <label className="text-sm text-gray-500 mt-2">Search:</label>
          <Input 
              variant="outline"
              dimension="small"    
              placeholder="eg. Sales"         
              onChange={(e) => handleSearch(e.target.value)}
            /> 
        </div>
      </div>

{/* <div className="md:inline-flex rounded-base shadow-sm -space-x-px mt-5 border border-default" role="group">
  <button type="button" className={`text-body bg-neutral-primary-soft border border-default hover:bg-accent hover:text-white focus:ring-3 focus:ring-neutral-tertiary-soft font-medium leading-5 rounded-s-base text-sm px-3 py-2 focus:outline-none
    ${selectedCategory === 'all' && "bg-accent text-white"}`}
  onClick={() => filterCategory('all')}>
    All
  </button>
  {LABELS_MAP?.map((category) => 
  <button type="button" className={`text-body hover:bg-accent hover:text-white focus:ring-3 focus:ring-neutral-tertiary-soft font-medium rounded-s-base text-sm px-3 py-2 focus:outline-none
    ${selectedCategory === category && "bg-accent text-white"}`} key={category}
  onClick={() => filterCategory(category)}>
    {category}  
  </button>
  )}
</div> */}


        {/* RATIOS */}
        <div className="flex flex-col md:flex-row gap-6 mt-4">
            <div className="w-full">
              {/*<h2 className="text-lg my-5">Recent</h2>*/}
              <div className="flex flex-wrap mb-5 gap-1">
              {LABELS?.map((ratio) => (
                <>
                
                <div key={ratio.id}>
                  <Button                
                      size="small"
                      className="root mr-2 mb-2"
                      variant="outline"
                      onClick={() => insertAtCursor(` ${ratio.name} `)}
                  >
                      {ratio.name}
                  </Button>
              </div>
              
              </>
              ))}
              </div>
            </div>
            
            
            
        </div>
        </div>
      {/*sql && <pre>{sql}</pre>*/}
    
    </section>
}
    </div>  
    <Footer />
    </>
  );
}